/**
 * Find the region for a postalcode
 */
const XHR = window.XMLHttpRequest
const mappingCache = {}

const loadMapping = (mappingUrl, callback) => {
  /**
   * Fetch, parse and cache mapping_url,
   * then call the callback with the
   * retrieved data.
   */
  if (mappingUrl in mappingCache) {
    callback(mappingCache[mappingUrl])
  } else {
    const request = new XHR()

    request.onreadystatechange = () => {
      if (request.readyState === XHR.DONE) {
        mappingCache[mappingUrl] = JSON.parse(request.responseText)
        callback(mappingCache[mappingUrl])
      }
    }

    request.open('GET', mappingUrl)
    request.send()
  }
}

const normalizeInput = (input) => {
  /**
   * Convert the input string to upper case,
   * remove all white space and limit it to
   * six characters.
   */
  return input.replace(/\s+/, '').toUpperCase().slice(0, 6)
}

export default (mappingUrl) => {
  return {
    match: (input, callback) => {
      /**
       * Try to find a matching region for the given input string
       * and call the callback with the matching region.
       *
       * If no match is found the callback is called with null.
       */
      input = normalizeInput(input)
      if (input.length >= 4) {
        loadMapping(mappingUrl, (data) => {
          let matches = {}
          Object.keys(data).forEach((key) => {
            if (key.indexOf(input) === 0) {
              matches[data[key]] = true
            }
          })
          matches = Object.keys(matches)
          matches.length === 1 ? callback(matches[0]) : callback(null)
        })
      } else {
        callback(null)
      }
    },
  }
}
